var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c7430f2a53e51446c839912676719b54.svg#s';
                    var viewUrl = 'sprites.c7430f2a53e51446c839912676719b54.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };